import { SUPPORTED_LOCALES } from './locales';

// Only pages with complete translations and prerendered HTML have language URLs.
export const LOCALIZED_PAGE_PATHS = [
  '/', '/store', '/team', '/team/zirui-qiu', '/stories', '/shipping', '/contact',
  '/guides/blitzball-vs-windball', '/customizer', '/custom-design',
  '/collections/2a-yoyos', '/collections/offstring-yoyos',
  '/collections/string-trick-yoyos', '/collections/yoyo-parts',
];

export const getLocalizedRoute = (path) => {
  const pathname = String(path).split(/[?#]/)[0].replace(/\/$/, '') || '/';
  if (pathname.length > 2048) return null;
  for (const { code } of SUPPORTED_LOCALES) {
    const prefix = code === 'en' ? '' : `/${code.toLowerCase()}`;
    if (prefix && pathname !== prefix && !pathname.startsWith(`${prefix}/`)) continue;
    const basePath = pathname.slice(prefix.length) || '/';
    const isProduct = /^\/store\/(?!\d+$)[a-z0-9][a-z0-9-]*$/.test(basePath);
    if (LOCALIZED_PAGE_PATHS.includes(basePath) || isProduct) return { basePath, locale: code };
  }
  return null;
};

export const getLocalizedPath = (path, locale) => {
  const route = getLocalizedRoute(path);
  if (!route || !SUPPORTED_LOCALES.some(({ code }) => code === locale)) return path;
  const suffix = String(path).match(/[?#].*$/)?.[0] || '';
  return `${locale === 'en' ? '' : `/${locale.toLowerCase()}`}${route.basePath}${suffix}`;
};

export const getLanguageAlternates = (path) => {
  const route = getLocalizedRoute(path);
  return route ? SUPPORTED_LOCALES.map(({ code }) => ({
    locale: code,
    path: getLocalizedPath(route.basePath, code),
  })) : [];
};
